import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Hub } from "aws-amplify/utils";
import { clearAllSessionData, logout } from "actions/session";
import { getProfile } from "actions/profile";
import { fetchAuthSession } from "aws-amplify/auth";

const SessionCheck = () => {
  const dispatch = useDispatch();
  const refreshTimeout = useRef(null);

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signedIn":
          console.log("Auth: user signed in");
          dispatch(getProfile());
          break;
        case "signedOut":
          console.log("Auth: user signed out");
          dispatch(clearAllSessionData());
          break;
        case "tokenRefresh":
          console.log("Auth: token refreshed");
          break;
        case "tokenRefresh_failure":
          console.log("Auth: token refresh failed");

          if (payload?.data?.error?.name === "NetworkError") {
            console.log("Auth: token refresh failed due to network. Allowing retry.");
          } else if (payload?.error?.name === "NotAuthorizedException") {
            console.log("Auth: token refresh failed due to NotAuthorizedException. Logging out.");
            dispatch(logout());
          } else {
            console.warn("Auth: token refresh failed due to unexpected error. Logging out.");
            dispatch(logout());
          }
          break;
        default:
          console.log("Auth Event:", payload.event);
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  useEffect(() => {
    const checkSession = async () => {
      try {
        var session = await fetchAuthSession();

        if (session && !session.tokens) {
          session = await fetchAuthSession({ forceRefresh: true });

          if (session && !session.tokens) {
            console.warn("Session Check no tokens in session. Logging out.");
            dispatch(logout());
          }
        }

        const exp = session.tokens?.idToken?.payload?.exp;
        if (!exp) return;

        const current = Math.floor(Date.now() / 1000);
        const remainingTime = exp - current;

        // If less than 30 seconds, refresh immediately
        if (remainingTime <= 30) {
          await fetchAuthSession({ forceRefresh: true });
        }

        // Clear previous timeout
        if (refreshTimeout.current) clearTimeout(refreshTimeout.current);

        // Schedule next check 30 seconds before token expiry or in 30s if token is long-lived
        const nextCheckIn =
          remainingTime > 40 ? (remainingTime - 30) * 1000 : 10000;
        console.log("nextCheckIn", nextCheckIn);
        refreshTimeout.current = setTimeout(checkSession, nextCheckIn);
      } catch (err) {
        console.warn("Error checking session:", err);
        if (err?.name === "NetworkError") {
          console.warn("Unable to check session due to network:", err);
        } else {
          console.warn("Session refresh failed:", err);
          dispatch(logout());
        }
      }
    };

    checkSession();

    return () => {
      if (refreshTimeout.current) clearTimeout(refreshTimeout.current);
    };
  }, [dispatch]);

  return null;
};

export default SessionCheck;
